import React from "react";

let customeStyleForParent = {
  parentRowStyle: {
    fontWeight: "700",
    backgroundColor: "rgb(139, 196, 63)",
  },
};

let customeStyleForChild = {
  childRowStyle: {
    fontWeight: "600",
    backgroundColor: "rgb(209, 239, 167)",
    color:"black"
  },
};
export const LocationPrefixList = (props) => {
  const { selectedChildLocation } = props;
  let detailList =
    props.pLocations &&
    props.pLocations.map((pLocs) => {
      let locationAssets = props.locationGroups[pLocs._id];
      let locs = null;
      if (pLocs.expanded) {
        locs =
          locationAssets &&
          locationAssets.map((loc) => {
            return (
              <AppFormRow
                handleSelectedLocation={props.handleSelectedLocation}
                value={loc.unitId}
                item={loc}
                key={loc._id}
                staticClass={props.staticClass}
                customStyle={
                  props.selectedChildLocation && selectedChildLocation._id === loc._id ? customeStyleForChild : props.customStyle
                }
              />
            );
          });
      }

      return (
        <React.Fragment key={pLocs._id}>
          <div className={"loc-parents" + addStaticClass(props.staticClass)}>
            <AppFormRow
              handleSelectedLocation={props.handleSelectpLocation}
              head={true}
              value={pLocs.unitId}
              item={pLocs}
              key={pLocs._id}
              staticClass={props.staticClass}
              customStyle={
                props.selectedParentLocation && props.selectedParentLocation._id === pLocs._id ? customeStyleForParent : props.customStyle
              }
            />

            <div className={"loc-children" + addStaticClass(props.staticClass)}>{locs}</div>
          </div>
        </React.Fragment>
      );
    });

  return <div className={"location-prefix-list location-button" + addStaticClass(props.staticClass)}> {detailList}</div>;
};
const AppFormRow = (props) => {
  return (
    <div
      className={`${props.head ? "loc-parent" : "loc-child"} ${addStaticClass(props.staticClass)}`}
      style={
        props.customStyle &&
        (props.customStyle.parentRowStyle
          ? props.customStyle.parentRowStyle
          : props.customStyle.childRowStyle
          ? props.customStyle.childRowStyle
          : props.customStyle.rowStyle
          ? props.customStyle.rowStyle
          : {})
      }
      onClick={(e) => {
        props.handleSelectedLocation(props.item);
      }}
    >
      {props.value}
    </div>
  );
};

function addStaticClass(staticMethod) {
  return staticMethod ? " staticClass" : "";
}



// WEBPACK FOOTER //
// ./src/components/LocationPrefixEditor/LocationPrefixList.jsx